<template>
    <router-view :class="{ 'wrapper-mobile': true, 'ios': ios, 'android': android }"/>
</template>

<script>
    import store from './app/store/index.js'
    import { isIOS, isAndroid } from 'mobile-device-detect';
    
    export default {
        name: 'App',
        store,        
        data(){
            return {
                ios: false,
                android: false
            };
        },        
        mounted() {
            this.ios = isIOS;
            this.android = isAndroid;
        }
    }
</script>

<style lang="scss">
  // Import Main styles for this application
  @import '@/app/assets/styles/bootstrap.scss';
  @import '@/app/assets/styles/app.scss';
  @import '@/app/assets/styles/smartBrain.scss';


</style>
